import classnames from 'classnames';
import React, { FC, HTMLAttributes } from 'react';

import { AngleDownSmall } from '@zooplus/icons';

import ImageIcon, { ImageIconType } from '../ImageIcons';

import styles from './FormControl.module.scss';

export type FormControlProps = HTMLAttributes<HTMLDivElement> & {
  hasError?: boolean;
  disabled?: boolean;
  focused?: boolean;
  inputIcon?: React.ReactNode;
  withinImageIconType?: ImageIconType;
  select?: boolean;
  innerClassname?: string;
};

const FormControl: FC<FormControlProps> = ({
  children,
  hasError = false,
  disabled = false,
  focused = false,
  className,
  inputIcon,
  withinImageIconType,
  select,
  innerClassname,
  ...otherProps
}) => {
  return (
    <div className={classnames('v3-form', className)}>
      <div className={styles.formElementWrapper}>
        <div
          {...otherProps}
          className={classnames(
            styles.formElement,
            innerClassname,
            select ? 'v3-form__select' : 'v3-form__input',
            focused ? styles.focused : '',
            disabled && (select ? 'v3-form__select--disabled' : 'v3-form__input--disabled'),
            hasError && (select ? 'v3-form__select--error' : 'v3-form__input--error'),
            inputIcon && !select && 'v3-form__input--withIcon',
          )}>
          {withinImageIconType && (
            <i>
              <ImageIcon className={styles.withinImageIcon} type={withinImageIconType} />
            </i>
          )}
        </div>
        {inputIcon && !select && (
          <i className={classnames('v3-form__icon', disabled && 'v3-form__icon--disabled')}>
            {inputIcon}
          </i>
        )}
        {select && (
          <i
            className={classnames(
              'v3-form__arrow',
              disabled && 'v3-form__arrow--disabled',
              hasError && 'v3-form__arrow--error',
            )}>
            {<AngleDownSmall />}
          </i>
        )}
      </div>
      {children}
    </div>
  );
};

export default FormControl;
